var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row brands-slider-widget" }, [
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "brands_slider_container" }, [
        _vm.categoryChildren
          ? _c(
              "div",
              {
                staticClass: "owl-carousel owl-theme brands_slider",
                attrs: { id: "brand-slider-" + _vm._uid },
              },
              _vm._l(_vm.categoryChildren, function (category, index) {
                return category.details
                  ? _c(
                      "a",
                      {
                        key: index,
                        staticClass: "item",
                        attrs: {
                          href: _vm.getCategoryUrl(category.url),
                          title: category.details[0].metaTitle,
                        },
                      },
                      [
                        category.details[0].image2Path
                          ? _c("img", {
                              staticClass: "owl-lazy",
                              attrs: {
                                "data-src":
                                  "/documents/" +
                                  category.details[0].image2Path,
                                alt: category.details[0].name,
                                loading: "lazy",
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e()
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "brands_nav brands_prev" }, [
      _c("i", { staticClass: "fa fa-chevron-left" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "brands_nav brands_next" }, [
      _c("i", { staticClass: "fa fa-chevron-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }